/**
 * @generated SignedSource<<c6be63a1187cb6573b0ad37fcc5c9898>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSwiper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SwiperItem_viewer">;
  readonly " $fragmentType": "ProductSwiper_viewer";
};
export type ProductSwiper_viewer$key = {
  readonly " $data"?: ProductSwiper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSwiper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSwiper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SwiperItem_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6b361a5ba5649c7021459d462a7fca1b";

export default node;
